import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const competitionTypeApi = generateNomenApi(`/nomen/competition-type`);

export const competitionTypeOptions = generateNomenOptions('competition-type', competitionTypeApi);
